// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"qE-z","smallCardRow":"rE-z","largeCardRow":"sE-z","productSearchRow":"tE-z","curatedRow":"uE-z"};